import StopAddress from 'components/form/StopAddress/styled';

export default StopAddress;
